import { GatsbyImage } from 'gatsby-plugin-image';
import { useContext } from 'react';

import { Container, Section } from 'components/GridV2';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { GetKOHOBtn } from 'components/rebrand/GetKOHOBtn';
import { LocaleContext } from 'components/rebrand/Layout';

import { IHomeCard } from 'typescriptDefs/pages/home';

import { useIsMobileSize } from 'helpers';
import { afTrackingByPage } from 'helpers/getAfTracking';

const Save = ({ content, cta, mobileImg }: IHomeCard) => {
  const locale = useContext(LocaleContext);
  const isMobile = useIsMobileSize();

  return (
    <Section className="py-64 md:py-96">
      <Container className="px-32 xs:px-0">
        <div className="mb-40 text-primary-500 md:[&>*]:text-center md:[&>p]:mx-auto md:[&>p]:w-[30%]">
          <CustomPortableText
            headingStyles={{
              h1: {
                className: 'md:mx-auto mb-24 md:mb-32 md:w-4/5 md:text-center',
                size: '2xl',
                as: 'h2',
              },
            }}
            content={content.heading}
          />
          <CustomPortableText content={content.description} />
        </div>
        <GetKOHOBtn
          className="mx-auto mb-48 block w-full md:mb-32 md:w-fit"
          buttonLocation="Spend section"
          queryParams={afTrackingByPage('HOME', cta?.registrationAdsetId)}
          trackEventProps={{
            category: 'www page Home',
            label: 'Save',
            locale,
            location: 'Save section',
          }}
          buttonClassName="w-full"
        >
          {cta?.text}
        </GetKOHOBtn>
        {isMobile && !!mobileImg ? (
          <GatsbyImage
            className="w-full rounded-9"
            image={mobileImg.img.asset.gatsbyImageData}
            alt={mobileImg.altText}
          />
        ) : (
          <GatsbyImage
            className="w-full rounded-16"
            image={content.image.img.asset.gatsbyImageData}
            alt={content.image.altText}
          />
        )}
      </Container>
    </Section>
  );
};

export default Save;
